import styled from "styled-components";

export const SectionPrinciplesContainer = styled.section(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginBottom: "40px",
  gap: "12px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
    marginBottom: "60px",
    gap: "64px",
  },
}));
